import { LocationDetailsResponse } from '@/core/domain/location-details/models/location-details.model';
import { LocationDetailsRepository } from '@/core/domain/location-details/repositories/location-details.repository';
import { environment } from '@/env/environment';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of, switchMap } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class LocationDetailsImplRepository extends LocationDetailsRepository {
    constructor(private readonly httpClient: HttpClient) {
        super();
    }

    override getLocationDetails(
        id: string,
    ): Observable<LocationDetailsResponse> {
        return this.httpClient
            .get<LocationDetailsResponse>(
                [
                    environment.alamoApi.BASE_HOST,
                    environment.alamoApi.ENDPOINTS.locationDetails,
                    id,
                ].join('/'),
            )
            .pipe(
                switchMap(
                    (locationDetailsResponse: LocationDetailsResponse) => {
                        const locationDetails: LocationDetailsResponse = {
                            type: locationDetailsResponse.type,
                            action: locationDetailsResponse.action,
                            notifications:
                                locationDetailsResponse.notifications,
                            data: locationDetailsResponse.data,
                        };

                        return of(locationDetails);
                    },
                ),
            );
    }
}
